import { GameCard } from "components/GameCard";
import { IconText } from "components/IconText";
import { CardPlaceholder } from "components/placeholders/CardPlaceholder";
import { GlobalContext } from "contexts/GlobalContext";
import { StoryDto } from "dtos/frankenstories/StoryDto";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetHallOfFamePreviewResult } from "results/frankenstories/GetHallOfFamePreviewResult";
import { RouteList } from "Routes";

export const ShowGame = (props: { g: StoryDto; label?: string }) => {
    const { g, label } = props;

    return (
        <div className="g-col-12 g-col-lg-4">
            <div className="vstack gap-3">
                {label && <h3 className="h4 text-center">{label}</h3>}

                <GameCard g={g} isAnonymous={true} showDate={false} />
            </div>
        </div>
    );
};

export const HallOfFamePreview = (props: { title?: string }) => {
    const { title } = props;

    const { gamesService, catchServerError } = useContext(GlobalContext);
    const { getHallOfFamePreview } = gamesService;

    const [result, setResult] = useState<GetHallOfFamePreviewResult>();

    useEffect(() => {
        let mounted = true;

        getHallOfFamePreview()
            .then(x => {
                if (mounted) {
                    setResult(x);
                }
            })
            .catch(catchServerError);

        return () => {
            mounted = false;
        };
    }, [catchServerError, getHallOfFamePreview]);

    return (
        <div className="vstack gap-4">
            {title && <h2 className="text-center">{title}</h2>}

            {result ? (
                <div className="grid gap-3 gap-lg-4 gap-xl-5">
                    <ShowGame g={result.promoStory1} label={result.promoLabel1} />
                    <ShowGame g={result.promoStory2} label={result.promoLabel2} />
                    <ShowGame g={result.promoStory3} label={result.promoLabel3} />
                </div>
            ) : (
                <div>
                    <div className="grid gap-3 gap-lg-4 gap-xl-5">
                        <div className="g-col-12 g-col-lg-4">
                            <CardPlaceholder />
                        </div>
                        <div className="g-col-12 g-col-lg-4">
                            <CardPlaceholder />
                        </div>
                        <div className="g-col-12 g-col-lg-4">
                            <CardPlaceholder />
                        </div>
                    </div>
                </div>
            )}

            <div className="d-flex justify-content-center">
                <Link to={RouteList.DiscoverHallOfFame} className="btn btn-dark icon-link">
                    <IconText icon="fas fa-trophy" text="Visit Hall of Fame" />
                </Link>
            </div>
        </div>
    );
};
